// @core/api/endpoints/document/list_documents.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListDocumentsResponse,
} from '../../../types/document';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/document';

/**
 * List documents
 * Returns a paginated list of documents with filtering by status, type, category, department, and review status.
 */
export async function ListDocuments(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListDocumentsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/documents`;
  const requestOptions = options;
  return client.get<ListDocumentsResponse>(requestPath, { ...requestOptions, params });
}
